import { FunctionComponent } from 'react'
import { SkeletonSeedValues, SkeletonView } from './SummaryLoadingSkeleton'
import styled, { css } from 'styled-components'

const StyledSummaryMarqueeItemLoader = styled.div`
  ${({
    theme: {
      color: {},
    },
  }) => css`
    opacity: 0.5;
    width: 250px;
    & > div {
      & > div {
        & > div:first-child {
          width: 60px;
        }
      }
    }
  `}
`

const SummaryMarqueeItemLoader: FunctionComponent = () => {
  return (
    <StyledSummaryMarqueeItemLoader>
      <SkeletonView
        seed={[
          {
            type: SkeletonSeedValues.ParagraphNatural,
            multiplier: 3,
          },
        ]}
      />
    </StyledSummaryMarqueeItemLoader>
  )
}
export default SummaryMarqueeItemLoader
